var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isInvalidValue)?_c('vx-no-info-dash'):_c('json-viewer',_vm._b({attrs:{"theme":_vm.theme,"value":_vm.value}},'json-viewer',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }